import { useStateParams } from './use-state-params';

export function useTabParam<Tab extends string>(defaultValue: Tab, deserializeTabParam: (tab: string) => Tab | null) {
  return useStateParams<Tab>(defaultValue, 'tab', value => value.toString(), deserializeTabParam);
}